import {
  FETCH_CLAIM_REPORTS_REQUEST,
} from './actionTypes';

export const fetchClaimReports = (payload) => ({
  type: FETCH_CLAIM_REPORTS_REQUEST,
  payload,
});
